import { useCallback, useEffect, useState } from 'react';
import { merchantFileService, MerchantFileData } from '../services/smsService';
import { leadService } from '../services/leadService';
import { useAuth } from '../contexts/AuthContext';

export function useMerchantFile(leadId: string | null) {
  const { user, isAdmin } = useAuth();
  const [data, setData] = useState<MerchantFileData | null>(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!leadId) return;
    setLoading(true);
    try {
      const file = await merchantFileService.getMerchantFile(leadId);
      setData(file);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [leadId]);

  useEffect(() => {
    setData(null);
    void load();
  }, [load]);

  const handleAddNote = async (body: string) => {
    if (!leadId) return;
    await leadService.addLeadNote(leadId, body);
    await load();
  };

  const handleUpdateNote = async (noteId: string, body: string) => {
    if (!leadId) return;
    await leadService.updateLeadNote(leadId, noteId, body);
    await load();
  };

  const handleDeleteNote = async (noteId: string) => {
    if (!leadId) return;
    await leadService.deleteLeadNote(leadId, noteId);
    await load();
  };

  return {
    data,
    loading,
    reload: load,
    currentUserId: user?.id,
    isAdmin: Boolean(isAdmin),
    handleAddNote,
    handleUpdateNote,
    handleDeleteNote,
  };
}
